
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Busserviceforpicnincinpune() {



    const cardData =
    {
        keyword: 'Bus Service for Picnic in Pune',
        heading: 'Amruta Travels: Bus Service for Picnic in Pune',
        headingDescription: 'Amruta Travels offers Bus Service for Picnic in Pune, providing a reliable and comfortable transportation solution for your group outings. Whether you are planning a school picnic, corporate retreat, family gathering, or a day trip with friends, our well-maintained buses ensure a smooth and enjoyable journey to popular picnic spots like Lonavala, Khandala, and Mulshi Lake . With experienced drivers, punctual service, affordable pricing, and 24/7 availability, we make your picnic travel simple and stress-free. Choose from our range of buses, including 32-seater, 35-seater, 45-seater, and 50-seater options, to suit your group size. Book your picnic bus with Amruta Travels and create memorable experiences with your group!',


        top: 'Top Places to Visit in Pune with Amruta Travels',

    "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],

     "services": [
    {
      "name": "Best Bus Service for Picnic in Pune",
      "description": "Planning a group picnic in or around Pune? Amruta Travels offers the best-in-class bus services for picnics, ensuring a fun and safe experience. With options ranging from 17 to 50-seater AC and non-AC buses, we cater to school outings, corporate day trips, and family getaways."
    },
    {
      "name": "Full Bus Booking Price",
      "description": "Get competitive full-bus booking rates with Amruta Travels in Pune. Whether you're booking a 32, 40, or 50-seater bus for a wedding, tour, or corporate event, we offer transparent pricing with no hidden charges—available for both city and outstation use."
    },
    {
      "name": "Bus Booking for One Day Trip",
      "description": "Amruta Travels provides easy and affordable bus booking options for one-day trips from Pune. Our fleet includes AC and non-AC buses suitable for school picnics, corporate outings, or spiritual tours like Ashtavinayak or Lonavala sightseeing."
    },
    {
      "name": "Bus Hire in Hadapsar",
      "description": "Amruta Travels offers reliable bus hire services in Hadapsar, Pune. Whether it's for a local school trip, a corporate shuttle, or an outstation tour, we provide clean, well-maintained buses with professional drivers and door-to-door pickup options."
    },
    {
      "name": "Bus Hire in Kharadi",
      "description": "Looking for a trusted bus hire service in Kharadi? Amruta Travels provides a range of AC and non-AC buses for rental in Kharadi for weddings, office events, and local or long-distance trips, backed by timely service and safety assurance."
    },
    {
      "name": "Bus Hire in Viman Nagar",
      "description": "Residents and offices in Viman Nagar can depend on Amruta Travels for seamless bus rentals. We offer tailored transport for corporate offices, schools, and wedding functions with punctual service and comfortable seating."
    },
    {
      "name": "Bus Hire in Kothrud",
      "description": "Amruta Travels provides quality bus rental services in Kothrud, Pune. Our fleet is available for weddings, excursions, family events, and office trips, with experienced drivers and clean interiors ensuring a smooth experience."
    },
    {
      "name": "Bus Hire on Rent in Pimpri Chinchwad",
      "description": "Amruta Travels offers dependable bus hire on rent in Pimpri Chinchwad (PCMC). We serve school trips, factory shifts, religious tours, and weddings with our modern buses and skilled chauffeurs who prioritize safety and punctuality."
    },
    {
      "name": "Bus Hire in Baner",
      "description": "Amruta Travels offers a wide range of bus rental options in Baner, Pune. Whether it’s a weekend trip, school tour, or office outing, we provide vehicles that are sanitized, well-maintained, and punctual for your convenience."
    },
    {
      "name": "Bus Hire in Kharadi Pune",
      "description": "Need a bus in Kharadi for your group travel needs? Amruta Travels delivers top-notch services for local and long-distance journeys, including family functions, corporate meets, and educational trips, with budget-friendly pricing."
    },
    {
      "name": "Bus Hire in Hadapsar Pune",
      "description": "From Hadapsar, Pune, Amruta Travels operates a fleet of buses for rent suitable for all kinds of events—from school picnics to religious pilgrimages. Choose from 17, 26, 35, 45, or 50-seater buses for your travel comfort."
    },
    {
      "name": "Mini AC Bus on Rent in Wanowrie, Pune",
      "description": "Travel in comfort from Wanowrie with Amruta Travels’ Mini AC Buses. Ideal for group tours, local trips, or airport transfers, our vehicles feature cozy seating, cooling systems, and trained drivers for a smooth travel experience."
    },
    {
      "name": "Mini AC Bus on Rent in Sinhagad Road Pune",
      "description": "Amruta Travels provides mini AC bus rental services in the Sinhagad Road area of Pune. Our buses are perfect for short tours, picnics, and family functions, with emphasis on comfort, cleanliness, and professional driving."
    },
    {
      "name": "Mini Bus on Rent in Aundh Pune",
      "description": "Hire a mini bus in Aundh, Pune with Amruta Travels for school outings, airport transfers, or short business trips. Our air-conditioned buses are well-maintained and come with courteous drivers who ensure timely pickups and drop-offs."
    },
    {
      "name": "Mini Bus on Rent in Hinjewadi for 1 Day",
      "description": "For one-day local or nearby trips from Hinjewadi, Amruta Travels offers mini bus rentals that are perfect for corporate groups, tech teams, or families. Enjoy safe, punctual travel in our modern mini buses with flexible schedules."
    },
    {
      "name": "Mini Bus on Rent in Wagholi",
      "description": "Amruta Travels offers mini bus rental services in Wagholi, Pune for weddings, school trips, and small group tours. Choose between AC and non-AC models with reliable service and experienced drivers at your convenience."
    }
  ],
  "tableData": [
    ["Best Bus Service for Picnic in Pune", "Full Bus Booking Price"],
    ["Bus Booking for One Day Trip", "Bus Hire in Hadapsar"],
    ["Bus Hire in Kharadi", "Bus Hire in Viman Nagar"],
    ["Bus Hire in Kothrud", "Bus Hire on Rent in Pimpri Chinchwad"],
    ["Bus Hire in Baner", "Bus Hire in Kharadi Pune"],
    ["Bus Hire in Hadapsar Pune", "Mini AC Bus on Rent in Wanowrie, Pune"],
    ["Mini AC Bus on Rent in Sinhagad Road Pune", "Mini Bus on Rent in Aundh Pune"],
    ["Mini Bus on Rent in Hinjewadi for 1 Day", "Mini Bus on Rent in Wagholi"]
  ],



"whychoose": [
  {
    "WhyChooseheading": "Comfortable Travel for Fun Outings",
    "WhyChoosedescription": "Amruta Travels offers Bus Service for Picnic in Pune, providing comfortable and air-conditioned buses to make your group outing enjoyable from start to finish."
  },
  {
    "WhyChooseheading": "Perfect for Schools, Colleges, and Families",
    "WhyChoosedescription": "Our buses are ideal for school picnics, college outings, and family get-togethers. We provide safe and reliable transportation tailored for group fun and relaxation."
  },
  {
    "WhyChooseheading": "Trained Drivers for a Safe Journey",
    "WhyChoosedescription": "Our drivers are experienced, courteous, and well-versed with popular picnic spots around Pune. They ensure a smooth, safe, and punctual travel experience."
  },
  {
    "WhyChooseheading": "Affordable Packages with No Hidden Costs",
    "WhyChoosedescription": "We offer cost-effective Bus Service for Picnic in Pune with transparent pricing. Enjoy your picnic without worrying about unexpected travel expenses."
  },
  {
    "WhyChooseheading": "Clean and Spacious Buses",
    "WhyChoosedescription": "Our buses are thoroughly cleaned and well-maintained, offering plenty of legroom and comfortable seating—ideal for day-long trips and fun-filled journeys."
  },
  {
    "WhyChooseheading": "Flexible Pickup Points and Timing",
    "WhyChoosedescription": "We provide flexible pickup and drop-off arrangements based on your picnic plan. Choose your preferred departure time and route for added convenience."
  },
  {
    "WhyChooseheading": "Fleet Options for All Group Sizes",
    "WhyChoosedescription": "From small family groups to large school batches, we offer various seating capacities, including 17-seater, 32-seater, and 50-seater buses to suit every picnic group."
  },
  {
    "WhyChooseheading": "Easy Booking and Friendly Support",
    "WhyChoosedescription": "Booking Bus Service for Picnic in Pune is quick and simple with Amruta Travels. Our support team is ready to help you plan and schedule your trip efficiently."
  }
]






























    }

const faqData = [
  {
    question: 'How can I book a bus for a picnic in Pune with Amruta Travels?',
    answer: 'Booking a bus for a picnic in Pune is easy with Amruta Travels. You can book online, call our support team, or visit our office. We’ll help you select the right bus for your group and picnic destination.',
  },
  {
    question: 'What types of buses are available for picnic trips?',
    answer: 'We offer 32, 35, 45, and 50 seater buses that are ideal for picnic trips. All buses are equipped with push-back seats, air conditioning, and ample luggage space, ensuring a comfortable and enjoyable outing.',
  },
  {
    question: 'Are your buses suitable for school, college, and corporate picnics?',
    answer: 'Yes, our buses are perfect for school picnics, college outings, and corporate getaways. We provide reliable and safe transportation for all age groups and types of organizations.',
  },
  {
    question: 'Are the buses clean and well-maintained for picnic trips?',
    answer: 'Absolutely. All our buses are regularly maintained, cleaned, and sanitized before every trip to ensure a safe and hygienic travel experience.',
  },
  {
    question: 'Do you provide a driver with the picnic bus rental?',
    answer: 'Yes, all our picnic bus rentals include a professional and experienced driver who ensures timely arrival and a smooth journey throughout your trip.',
  },
  {
    question: 'Can I plan multiple pickup points for our picnic group?',
    answer: 'Yes, we offer flexible pickup and drop-off options to accommodate groups coming from different locations in Pune. Just share your plan and we’ll take care of the logistics.',
  },
  {
    question: 'How much does it cost to rent a bus for a picnic in Pune?',
    answer: 'The rental price depends on the bus size, destination, and trip duration. Contact us with your picnic details for a customized and transparent quote.',
  },
  {
    question: 'Do you offer outstation bus services for picnic spots outside Pune?',
    answer: 'Yes, we provide outstation bus services for popular picnic spots near Pune like Lonavala, Mahabaleshwar, Lavasa, and more. We ensure a comfortable ride for long distances.',
  },
  {
    question: 'Why choose Amruta Travels for picnic bus services in Pune?',
    answer: 'Amruta Travels is known for its reliable buses, professional drivers, and excellent customer service. We make sure your picnic transportation is hassle-free, punctual, and enjoyable.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Ajay More',
    role: 'School Coordinator, Pune',
    text: 'We hired a 45-seater bus from Amruta Travels for our school picnic to Sinhagad Fort. The bus was very comfortable, clean, and the driver was courteous and punctual. The kids had a great time!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Shraddha Kulkarni',
    role: 'HR Executive, Pune',
    text: 'Our company booked a 50-seater bus for a team picnic to Lavasa. The service was excellent from start to finish. The bus was in great condition and everyone had a smooth and fun trip.',
    rating: 5,
  },
];








































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Service for Picnic in Pune",
  "image": "https://bushireinpune.com/assets/images/bus-service-for-picnic-pune.jpg",
  "description": "Book a mini bus or full-sized bus for your picnic trip in Pune. We offer buses for one-day trips to destinations around Pune, with hire options in areas like Hadapsar, Kharadi, Viman Nagar, Kothrud, and more.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "4621"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "40", // Adjust based on per km or flat rate for picnic bus rental
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/bus-service-for-picnic-in-pune"
  }
};





    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | Bus Service for Picnic in Pune | Mini & Full Bus Hire for Picnic Trips | Amruta Travels</title>
  <meta 
    name="description" 
    content="Book the best bus service for picnics in Pune. Choose from mini AC buses or larger buses for your one-day picnic trips from Hadapsar, Kharadi, Viman Nagar, and other areas around Pune." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/18.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Busserviceforpicnincinpune;